var _g, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorPeaker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_623)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_623)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.5334,
    height: 31.08,
    transform: "translate(-2.28003 -0.782959)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_623)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.551,
    cy: 11.8563,
    r: 21.3071,
    fill: "#00E5FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1_623)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.3276,
    cy: 31.782,
    r: 19.9258,
    fill: "#FFD5FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1_623)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -10.0673,
    cy: 1.16817,
    rx: 20.5301,
    ry: 21.1517,
    fill: "#FF007E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1_623)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.1828,
    cy: 24.6509,
    rx: 12.9845,
    ry: 15.4882,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1_623)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.1373,
    cy: 9.1454,
    rx: 9.56574,
    ry: 21.1517,
    fill: "#7F9FFF"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9838,
    cy: 14.7389,
    r: 14.6014,
    transform: "rotate(152.841 14.9838 14.7389)",
    fill: "url(#paint0_radial_1_623)",
    fillOpacity: 0.84
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 14.9838,
    cy: 14.739,
    r: 14.6014,
    fill: "url(#paint1_radial_1_623)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.9838,
    cy: 14.739,
    r: 14.6014,
    fill: "url(#paint2_radial_1_623)",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_623",
    x: -11.5695,
    y: -23.2642,
    width: 70.2408,
    height: 70.2409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.90667,
    result: "effect1_foregroundBlur_1_623"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1_623",
    x: -21.4115,
    y: -1.95708,
    width: 67.4783,
    height: 67.4782,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.90667,
    result: "effect1_foregroundBlur_1_623"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1_623",
    x: -47.2287,
    y: -36.6148,
    width: 74.3227,
    height: 75.5659,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.31563,
    result: "effect1_foregroundBlur_1_623"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1_623",
    x: 4.3849,
    y: -4.65069,
    width: 53.5958,
    height: 58.6031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.90667,
    result: "effect1_foregroundBlur_1_623"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1_623",
    x: 23.7582,
    y: -25.8196,
    width: 46.7582,
    height: 69.9301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.90667,
    result: "effect1_foregroundBlur_1_623"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2452 11.9707) rotate(87.862) scale(20.9981)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.356548,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753497,
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.8207 10.077) rotate(83.6476) scale(19.3824)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.106603,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1_623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.8207 10.077) rotate(83.6476) scale(19.3824)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.106603,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_623"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.391846,
    y: 0.14978,
    width: 29.2028,
    height: 29.2028,
    rx: 14.6014,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.5334,
    height: 31.08,
    fill: "white",
    transform: "translate(-2.28003 -0.782959)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPeaker);
export default __webpack_public_path__ + "static/media/color_peaker.f0892692a590cd15d87e7e7f757b22fa.svg";
export { ForwardRef as ReactComponent };